// extracted by mini-css-extract-plugin
module.exports = {"Provider":"NotificationProvider_Provider__3Bb9A"};